import React from 'react';
import { Link } from 'react-router-dom';

import bookConductor from '../assets/images/art/book-conductor.png';

class ConductorButton extends React.Component {
    render() {
        return (
            <div className="conductor-btn"><Link to="/book/" rel="noopener noreferrer"><img src={bookConductor} alt="" /></Link></div>
        );
    }
}

export default ConductorButton;